import {permissionActionNameMaxLength, permissionActionNameMinLength} from 'api/gen/PermissionActionName';
import {permissionCodeMaxLength, permissionCodeMinLength} from 'api/gen/PermissionCode';
import {permissionCommentMaxLength, permissionCommentMinLength} from 'api/gen/PermissionComment';
import {permissionControllerNameMaxLength, permissionControllerNameMinLength} from 'api/gen/PermissionControllerName';
import {t} from 'app/translations';
import {EskotValidator} from 'utils/eskot-validator';
import {Errors} from 'utils/validator';

import {CreateOrUpdatePermissionFormValues} from '../../types/permission-form-values';

const te = t('admin');

/**
 * Validates permission form values.
 *
 * @param values Permission form state.
 * @returns Validation errors keyed by form field.
 */
export const validate =
    (values: CreateOrUpdatePermissionFormValues): Errors<CreateOrUpdatePermissionFormValues> => {
        const validator = new EskotValidator(values);

        validator.nonEmpty('actionName', te('action'));
        validator.maxStringLength('actionName', permissionActionNameMaxLength, te('action'));
        validator.minStringLength('actionName', permissionActionNameMinLength, te('action'));

        validator.nonEmpty('code', te('code'));
        validator.maxStringLength('code', permissionCodeMaxLength, te('code'));
        validator.minStringLength('code', permissionCodeMinLength, te('code'));

        if (values.comment) {
            validator.maxStringLength('comment', permissionCommentMaxLength, te('comment'));
            validator.minStringLength('comment', permissionCommentMinLength, te('comment'));
        }

        validator.nonEmpty('controllerName', te('controller'));
        validator.maxStringLength('controllerName', permissionControllerNameMaxLength, te('controller'));
        validator.minStringLength('controllerName', permissionControllerNameMinLength, te('controller'));

        validator.nonEmpty('discriminatorId', te('discriminator'));

        validator.nonEmpty('userEnable', te('userEnable'));

        return validator.generateErrorsObject();
    };
